"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKING_SOURCE_UNKNOWN = exports.TRACKING_SOURCE_SEARCH = exports.TRACKING_SOURCE_PROFILE = void 0;
// constants for passing to avail tile components as to where the placement
// is rendered
const TRACKING_SOURCE_PROFILE = exports.TRACKING_SOURCE_PROFILE = 'avail_tile_profile';
const TRACKING_SOURCE_SEARCH = exports.TRACKING_SOURCE_SEARCH = 'avail_tile_search';
const TRACKING_SOURCE_UNKNOWN = exports.TRACKING_SOURCE_UNKNOWN = 'avail_tile_unknown';